export const standardPageHeader = {
  width: '25em',
  fontSize: '4vw',
  bottom: 0,
  right: 0,
  rotation: -33,
  transformOrigin: 'bottom left',
  transform: 'translateX(65%) translateY(85%)',
};
